// api/recurrent_reservations
// 繰り返し予約に関するAPIを実装する

import Api from './api_base'

export default {
  // GET /recurrent_reservations トークンで指定されたユーザに関係する繰り返し予約の情報を取得する
  get: () => {
    return Api.get('/recurrent_reservations')
    .catch((err) => {
      alert(err.response.data.message)
      console.log(err)
    })
  },
  // POST /recurrent_reservations 繰り返し予約を登録する（登録された繰り返しのルールに従って，個々の予約情報も登録される）
  post: (reservation) => {
    return Api.post('/recurrent_reservations', reservation)
    .catch((err) => {
      alert(err.response.data.message)
      console.log(err)
    })
  },
  // PUT /recurrent_reservations/{id} 繰り返し予約の情報を変更する（紐付けられた個々の予約情報も変更される）
  put: (id, reservation) => {
    return Api.put('/recurrent_reservations/' + id, reservation)
    .catch((err) => {
      alert(err.response.data.message)
      console.log(err)
    })
  },
  // DELETE /recurrent_reservations/{id} 繰り返し予約の情報を削除する（紐付けられた個々の予約情報も削除される）
  delete: (id, fromReservaitonId) => {
    return Api.delete('/recurrent_reservations/' + id + '?from=' + fromReservaitonId)
    .catch((err) => {
      alert(err.response.data.message)
      console.log(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/recurrent_reservations.js